import { render } from "./BasicInfoView.vue?vue&type=template&id=8f0821f2&scoped=true"
import script from "./BasicInfoView.vue?vue&type=script&lang=js"
export * from "./BasicInfoView.vue?vue&type=script&lang=js"

import "./BasicInfoView.vue?vue&type=style&index=0&id=8f0821f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0821f2"]])

export default __exports__